import React, { useState } from 'react';
import { useGlobalContext } from '../../../store/global';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { confirmHotel } from "../../../utils/data";

const ConfirmHotel = (props) => {
  const { closeModal, modalData, setUser, openModal } = useGlobalContext();
  const { t } = useTranslation();
  const [submitting, setSubmitting] = useState(false);
  const goToProfilePage = () => {
    closeModal();
    props.history.push("/profile/edit?from=modal");
  };
  
  const handleRegister = async (e) => {
    e.preventDefault();
    if (submitting) return;
    
    if (modalData) {
      setSubmitting(true);
      const data = {
        name: modalData.name,
        surname: modalData.surname,
        country: modalData.country,
        city: modalData.city,
        brand: modalData.brand,
        hotel: modalData.hotel,
      };
      try {
        const res = await confirmHotel(data);
        const payload = res?.data || res;
        if (payload?.code === "VALIDATION_PENDING") {
          closeModal();
          openModal("alert-validation", false);
          return;
        }
        if (res && res.status >= 200 && res.status < 300) {
          setUser(payload || {});
          closeModal();
        }
      } catch (err) {
        console.error('confirmHotel failed', err);
      } finally {
        setSubmitting(false);
      }
    }
  };


  return (
      <div className="popup-inner admin-msg" style={{ maxWidth: '650px' }}>
        <div className="popup-title">{t('admin_msg_modal_title')}</div>
        <div className="popup-content">
          <div className="popup-content--icon">
            <img src="/assets/images/alert.svg" alt="alert logo" />
          </div>
          <div className="popup-content--text">
            <h1 className="popup-content--text--title">{t("admin_msg_modal_hello_user", {name: modalData.name})}</h1>
            <p className="popup-content--text--alert">{t("admin_msg_modal_still_working_at_hotel", {hotelName: modalData.hotelName})}</p>
          </div>
        </div>
        <div className="popup-actions">
          <div className="popup-actions--button popup-actions--button__cancel" onClick={goToProfilePage}>{t("admin_msg_modal_edit_hotel")}</div>
          <div className={`popup-actions--button popup-actions--button__confirm${submitting ? ' disabled' : ''}`} onClick={handleRegister}>{t("admin_msg_modal_confrim_stay")}</div>
        </div>  
    </div>
  );
}
export default withRouter(ConfirmHotel);
